import { render, staticRenderFns } from "./QuickTipsSearchFile.vue?vue&type=template&id=ec94492c&scoped=true&"
import script from "./QuickTipsSearchFile.vue?vue&type=script&lang=js&"
export * from "./QuickTipsSearchFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec94492c",
  null
  
)

export default component.exports